/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Features_TitleInputs */

const en_mk_features_title = /** @type {(inputs: Mk_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All your work, connected.`)
};

const id_mk_features_title = /** @type {(inputs: Mk_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seluruh pekerjaan, saling terhubung.`)
};

/**
* | output |
* | --- |
* | "All your work, connected." |
*
* @param {Mk_Features_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_features_title = /** @type {((inputs?: Mk_Features_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Features_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_features_title(inputs)
	return en_mk_features_title(inputs)
});